import React from "react";
import { Button, ButtonProps } from "reactstrap";
import styled, { css } from "styled-components";
import buttonColourStyle from "../../helpers/buttonColourStyle";

interface ICustomProps extends ButtonProps {
  isCircle?: boolean;
}

const StyledButton = styled(Button).attrs((props: ICustomProps) => ({
  isCircle: props.isCircle
}))`
  background-color: ${props => props.color};
  border-color: ${props => props.color};
  color: #ffffff;
  ${props =>
    props.isCircle &&
    css`
      border-radius: 50% !important;
      height: 2.375rem;
      padding: 0 !important;
      width: 2.375rem;
    `};
`;

const CustomButton = ({
  children,
  color,
  isCircle,
  ...props
}: ICustomProps) => {
  const buttonColour = buttonColourStyle(color);
  return (
    <StyledButton color={buttonColour} isCircle={isCircle} {...props}>
      {children}
    </StyledButton>
  );
};

export default CustomButton;
